<template>
<div>
    <button  v-if="!loading" type="button" @click="appendDataToModal"  class="btn btn-icon">
      <i class="fas fa-info"></i>
    </button>
    <span v-else class="spinner-border spinner-border-sm"></span>
    <div id="description_modal"  class="modal fade rtl" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div id="tx_title">
                    </div>
                    <div id="tx_log" class="ml-1">
                    </div>
                    <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                </div>
                <div id="data_sheet" class="modal-body mb-4">
                    <table id="statistic_details" class="table table-hover">
                        <thead>
                        <tr>
                            <th class="table-info" colspan="2">{{ $t('label.before_transaction_status') }}</th>
                        </tr>
                        </thead>
                        <tbody id="initial_status">
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import {reportService} from "@/common/api.service";
import toastr from "toastr";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
        }
    },
    methods: {
        async appendDataToModal() {
           this.loading = true;
           await reportService.getPfTerminalDetails(this.row.id)
             .then( (res) => {
                this.data = res.data.data
            }).catch(() => {
                this.isError = true;
                this.toastr.error(i18n.t('message.an_error_accord'))
           }).finally(() => {
                this.loading = false;
           })
            if (this.isError)
                return;
            $("#description_modal").modal('show')
            function simpleText(data, title){
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                    '<td>' + data + '</td></tr>'
            }
            let statistic_details = $('#statistic_details').empty()
            let e = '<thead><tr><th class="table-info" colspan="2">' + i18n.t('label.other_details') + '</th></tr></thead><tbody>'
            if (this.data.iban_number) {
                e += simpleText(this.data.iban_number, i18n.t('reports.terminals.iban_number'))
            }
            if (this.data.reference_number) {
                e += simpleText(this.data.reference_number, i18n.t('reports.terminals.reference_number'))
            }
            if (this.data.tracking_number) {
                e += simpleText(this.data.tracking_number, i18n.t('reports.terminals.tracking_number'))
            }
            if (this.data.shop_id) {
                e += simpleText(this.data.shop_id, i18n.t('reports.terminals.shop_id'))
            }
            if (this.data.payment_time) {
                e += simpleText(this.data.payment_time, i18n.t('reports.terminals.payment_time'))
            }
            e += '</tbody>'
            statistic_details.append(e)
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>

<style>

</style>
